import { render, staticRenderFns } from "./detailPopup.vue?vue&type=template&id=16bd33a0&scoped=true&"
import script from "./detailPopup.vue?vue&type=script&lang=js&"
export * from "./detailPopup.vue?vue&type=script&lang=js&"
import style0 from "./detailPopup.vue?vue&type=style&index=0&id=16bd33a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bd33a0",
  null
  
)

export default component.exports